(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elsie-service-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('er-announcement-bar')) {
    customElements.define('er-announcement-bar', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.messages = Array.from(this.querySelectorAll('[data-message]'));
        this.track = this.querySelector('[data-messages]');
        this.rotationControl = this.querySelector('[data-rotation-control]');
        this.previousControl = this.querySelector('[data-previous]');
        this.nextControl = this.querySelector('[data-next]');
        if (this.messages.length < 2 || !this.track || !this.rotationControl) return;
        this.controller = new AbortController();
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.index = 0;
        this.interval = Math.max(5, Math.min(12, Number(this.dataset.interval) || 7)) * 1000;
        this.userPaused = this.dataset.autoplay !== 'true' || this.motionQuery.matches || this.contains(document.activeElement);
        this.hovered = this.hoverQuery.matches && this.matches(':hover');
        this.rotationIntent = null;
        this.timer = null;
        this.dataset.reducedMotion = String(this.motionQuery.matches);
        const options = { signal: this.controller.signal };
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !this.hoverQuery.matches) return;
          this.hovered = true;
          this.syncRotation();
        }, options);
        this.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          this.syncRotation();
        }, options);
        this.addEventListener('focusin', () => {
          this.userPaused = true;
          this.syncRotation();
        }, options);
        this.rotationControl.addEventListener('pointerdown', () => {
          this.rotationIntent = this.userPaused ? 'play' : 'pause';
        }, options);
        this.rotationControl.addEventListener('pointercancel', () => {
          this.rotationIntent = null;
        }, options);
        this.rotationControl.addEventListener('keydown', () => {
          this.rotationIntent = null;
        }, options);
        this.rotationControl.addEventListener('click', () => {
          const action = this.rotationIntent || (this.userPaused ? 'play' : 'pause');
          this.rotationIntent = null;
          this.userPaused = action === 'pause';
          this.syncRotation();
        }, options);
        this.previousControl.addEventListener('click', () => this.selectMessage(this.index - 1), options);
        this.nextControl.addEventListener('click', () => this.selectMessage(this.index + 1), options);
        document.addEventListener('visibilitychange', () => this.syncRotation(), options);
        this.onMotionChange = () => {
          this.dataset.reducedMotion = String(this.motionQuery.matches);
          if (this.motionQuery.matches) this.userPaused = true;
          this.syncRotation();
        };
        this.onHoverChange = () => {
          this.hovered = this.hoverQuery.matches && this.matches(':hover');
          this.syncRotation();
        };
        this.motionQuery.addEventListener('change', this.onMotionChange);
        this.hoverQuery.addEventListener('change', this.onHoverChange);
        this.setMessage(0);
        this.setAttribute('data-ready', '');
        this.syncRotation();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.timer = null;
        this.controller?.abort();
        this.controller = null;
        this.motionQuery?.removeEventListener('change', this.onMotionChange);
        this.hoverQuery?.removeEventListener('change', this.onHoverChange);
        this.removeAttribute('data-ready');
      }

      setMessage(index) {
        this.index = (index + this.messages.length) % this.messages.length;
        this.messages.forEach((message, position) => {
          const active = position === this.index;
          message.classList.toggle('is-active', active);
          message.setAttribute('aria-hidden', String(!active));
          message.inert = !active;
          message.querySelectorAll('a').forEach(link => {
            if (active) link.removeAttribute('tabindex');
            else link.setAttribute('tabindex', '-1');
          });
        });
        this.dataset.activeIndex = String(this.index);
      }

      selectMessage(index) {
        this.userPaused = true;
        this.syncRotation();
        this.setMessage(index);
      }

      syncRotation() {
        clearTimeout(this.timer);
        this.timer = null;
        const running = !this.userPaused && !this.hovered && !document.hidden;
        this.dataset.rotationState = running ? 'playing' : 'paused';
        this.rotationControl.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.rotationControl.querySelector('[data-pause-icon]').hidden = this.userPaused;
        this.rotationControl.querySelector('[data-play-icon]').hidden = !this.userPaused;
        this.track.setAttribute('aria-live', this.userPaused ? 'polite' : 'off');
        if (!running || !this.isConnected) return;
        this.timer = setTimeout(() => {
          this.timer = null;
          this.setMessage(this.index + 1);
          this.syncRotation();
        }, this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elsie-shopping-help"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const revealPolicyAnchor = (hash, scroll) => {
      if (!['#shipping', '#returns', '#tracking', '#faq'].includes(hash)) return;
      const target = document.getElementById(hash.slice(1));
      if (!target || !target.closest('.er-shipping-policy')) return;
      if (target.matches('details')) target.open = true;
      if (scroll) requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    };
    document.addEventListener('click', (event) => {
      const link = event.target.closest('.er-shipping-policy a[href^="#"]');
      if (link) revealPolicyAnchor(link.getAttribute('href'), false);
    });
    window.addEventListener('hashchange', () => revealPolicyAnchor(window.location.hash, true));
    document.addEventListener('shopify:section:load', () => revealPolicyAnchor(window.location.hash, true));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => revealPolicyAnchor(window.location.hash, true), { once: true });
    } else {
      revealPolicyAnchor(window.location.hash, true);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
